var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAssign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAssign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chatroom",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_msg-videostreaming-Copy",
    transform: "translate(-55.000000, -579.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5,579 C63.5375661,579 66,581.462434 66,584.5 C66,587.537566 63.5375661,590 60.5,590 C57.4624339,590 55,587.537566 55,584.5 C55,581.462434 57.4624339,579 60.5,579 Z M60.5,579.916667 C57.9686949,579.916667 55.9166667,581.968695 55.9166667,584.5 C55.9166667,587.031305 57.9686949,589.083333 60.5,589.083333 C63.0313051,589.083333 65.0833333,587.031305 65.0833333,584.5 C65.0833333,581.968695 63.0313051,579.916667 60.5,579.916667 Z M58.7276102,582.4 L59.4665893,585.501782 L60.2112529,582.4 L60.7228538,582.4 L61.4675174,585.527921 L62.2064965,582.4 L62.9,582.4 L61.774478,586.8 L61.1548724,586.8 L60.4443155,583.91604 L59.7508121,586.8 L59.125522,586.8 L58,582.4 L58.7276102,582.4 Z",
    id: "icAssign"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssign);
export default __webpack_public_path__ + "static/media/icAssign.205aa3baefec8006a5d2077297d4f1f0.svg";
export { ForwardRef as ReactComponent };